import React from 'react'
import PropTypes from 'prop-types'

import { getSubscriptionColumns } from '../Helper/helper.js'
import { INSIGHTS_ROW_SIZE } from '../Helper/constants.js'

import SuccessMessage from '../Modules/SuccessMessage.jsx'

import DOMPurify from 'dompurify'

function InsightsTopics({ topics, success, handleSubscribe }) {
  const topicColumns = getSubscriptionColumns(topics, INSIGHTS_ROW_SIZE)

  return (
    topics.length > 0 && (
      <React.Fragment>
        <h3 className="u-marginBottom3gu">
          Topics{' '}
          <span className="u-marginLeft1gu u-textNormal u-textSecondary">
            Get real-time updates on the topics that interest you most.
          </span>
        </h3>

        {success && <SuccessMessage></SuccessMessage>}

        <div
          id="Insights-topics"
          className="Grid-striper"
          data-analytics="cesc-Topics"
        >
          {topicColumns.map((topicsContent, parentIndex) => {
            return (
              <div key={'topicsContent' + parentIndex} className="Grid">
                {topicsContent.map((topic, childIndex) => {
                  return (
                    <div
                      key={'topic' + childIndex}
                      className="Insights-topic u-lg-size4of12 u-sm-sizeFull u-paddingHoriz2gu u-paddingVert4gu"
                    >
                      <label htmlFor={'topicCheckBox' + topic.id}>
                        <input
                          id={'topicCheckBox' + topic.id}
                          checked={topic.checked}
                          onChange={handleSubscribe}
                          value={topic.id}
                          type="checkbox"
                          aria-label={topic.name}
                          className="Subscription-checkbox"
                          data-analytics="cesc-subscribe-checkbox"
                        ></input>
                        <h4
                          className="u-marginLeft2gu"
                          aria-label={topic.name}
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(topic.name),
                          }}
                        ></h4>
                      </label>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </React.Fragment>
    )
  )
}

InsightsTopics.propTypes = {
  topics: PropTypes.array,
  success: PropTypes.bool,
  handleSubscribe: PropTypes.func.isRequired,
}

export default InsightsTopics
